export function isActivePath(pathname: string, to: string, end?: boolean) {
  if (to === '/') return pathname === '/'
  if (end) return pathname === to
  return pathname === to || pathname.startsWith(to + '/')
}
